import { legendaStati, leaveLabel } from './../../constants/constants';
import { IonicPage, NavController, NavParams, Keyboard, AlertController } from "ionic-angular";
import { Component } from "@angular/core";

import { CoreProvider } from "../../providers/core-service/core-service";
import { NetworkConnectionProvider } from "../../providers/network-connection/network-connection";

import { Week } from "../../model/Week";
import { User } from "../../model/user";
import { Subscription } from 'rxjs/Subscription';
import { LoginPage } from '../login/login';

import { DatePipe } from '@angular/common';

/**
 * Generated class for the Weekly page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'ad-view',
  templateUrl: 'ad-view.html',
})
export class ADViewPage {

  show_loading: boolean = true;
  labelWeek = 'Week';

  week_days: Array<string> = [];

  swipeDays: number = 4;
  week_range: [Date, Date];
  week_differ: number = 0;
  week_binding: Week[] = [];

  weeksbinding: Subscription;

  private index_list: string[] = ['1_am', '1_pm', '2_am', '2_pm', '3_am', '3_pm',
    '4_am', '4_pm', '5_am', '5_pm', '6_am', '6_pm', '7_am', '7_pm']; //indice per settimana in ricerca

  private statusLabel = {
    "Headquarter": "cellStyleHeadQuarter",
    "Bank Holiday": "cellStyleHoliday",
    "Travel": "cellStyleTravel",
  };

  prevShow: boolean = true;
  nextShow: boolean = true;

  userListToShow: User[] = [];

  private onNext = true;
  private onPrev = true;
  private checkNextOnce = false;
  private checkPrevOnce = false;

  private device: any;

  private travelSearch: boolean = false;

  showAutocomplete = false;
  showTravelEvidence = true;
  private moveSearch: number = 0;
  querySearch = '';
  autocomplete = [];
  manager = [];
  places = [];
  elementFind: string[];
  resultsEmpty: boolean = false;

  constructor(
    public navCtrl: NavController, public navParams: NavParams,
    public network: NetworkConnectionProvider,
    private keyboard: Keyboard,
    private coreService: CoreProvider,
    private alertCtrl: AlertController
  ) {
    this.week_range = this.coreService.getWeekRange();
    this.week_days = this.defineWeekDays();


    this.device = this.coreService.getDevice();
  }

  /**
   *  Device width
   */
  getTabletDevice(): boolean {
    //console.log(device);

    if (this.device[1] >= 760) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Swipe settimana
   */
  onSwipe(event: any) {
    if (event.direction == 4) {
      if (this.prevShow)
        this.moveToPreviousWeek();
    } else if (event.direction == 2) {
      if (this.nextShow)
        this.moveToNextWeek();
    }
  }

  /**
   * Swipe mezza settimana
   * @param event 
   */
  onSwipeDays(event: any) {
    if (event.direction == 4) {
      this.swipeDays = 4;
    } else if (event.direction == 2) {
      this.swipeDays = 2;
    }
  }

  /**
   * Restituisce la classe in base allo stato
   * @param value 
   */
  getStateLegendColor(value: string, state?: string) {

    if (this.travelSearch) {
      if (state)
        return this.statusLabel.Travel;
      else
        return this.statusLabel["Bank Holiday"]
    } else {
      for (let i in this.statusLabel) {
        if (value == i) {
          return this.statusLabel[i];
        } else if (this.coreService.getLeaveLabel().indexOf(value) > -1) {
          return "cellStyleLeave";
        }
      }

      return this.statusLabel.Travel;
    }
  }


  loadActual() {
    this.coreService.getActualWeek();

    this.coreService.getofflineNextBlock().then(result => {
      this.nextShow = result;
    });

    this.coreService.getofflinePrevBlock().then(result => {
      this.prevShow = result;
    });
  }

  ionViewWillEnter() {

    let resetDate = this.navParams.get('resetDate');

    if (resetDate) {
      this.coreService.setSearchedData(null);
      this.coreService.resetWeekPointer(true);
    }

    //this.week_range = firebase.getWeekRange();

    this.weeksbinding = this.coreService.getWeek().subscribe(week => {
      if (this.coreService.getWeekDiffer() == 0) {
        this.labelWeek = 'Current Week';
      } else if (this.coreService.getWeekDiffer() < 0) {
        this.labelWeek = '' + this.coreService.getWeekDiffer() + ' Week';
      } else if (this.coreService.getWeekDiffer() > 0) {
        this.labelWeek = '+' + this.coreService.getWeekDiffer() + ' Week';
      }

      this.week_binding = week;
      this.purgeWeek();

      this.week_range = this.coreService.getWeekRange();

      this.week_days = this.defineWeekDays();

      if (this.onNext && !this.checkNextOnce) {
        this.checkNextOnce = true;
        this.coreService.getofflineNextBlock().then(result => {
          this.nextShow = result;
        });
      }


      if (this.onPrev && !this.checkPrevOnce) {
        this.checkPrevOnce = true;
        this.coreService.getofflinePrevBlock().then(result => {
          this.prevShow = result;
        });
      }

      this.mantainResearch();

    });

    this.network.checkConnection().subscribe(online => {

      if ((online || this.coreService.initialized)) {
        if (!this.weeksbinding) {
          //console.log('binding week per online');
          this.weeksbinding = this.coreService.getWeek().subscribe(week => {

            //console.log(this.coreService.getWeekDiffer());

            if (this.coreService.getWeekDiffer() == 0) {
              this.labelWeek = 'Current Week';
            } else if (this.coreService.getWeekDiffer() < 0) {
              this.labelWeek = '' + this.coreService.getWeekDiffer() + ' Week';
            } else if (this.coreService.getWeekDiffer() > 0) {
              this.labelWeek = '+' + this.coreService.getWeekDiffer() + ' Week';
            }
            //console.log(week);

            this.week_binding = week;
            this.purgeWeek();

            this.week_range = this.coreService.getWeekRange();

            this.week_days = this.defineWeekDays();

            if (this.onNext && !this.checkNextOnce) {
              this.checkNextOnce = true;
              this.coreService.getofflineNextBlock().then(result => {
                this.nextShow = result;
              });
            }


            if (this.onPrev && !this.checkPrevOnce) {
              this.checkPrevOnce = true;
              this.coreService.getofflinePrevBlock().then(result => {
                this.prevShow = result;
              });
            }

            this.mantainResearch();

          });
        } else {
          if (this.onNext)
            this.coreService.getofflineNextBlock().then(result => {
              this.nextShow = result;
            });

          if (this.onPrev)
            this.coreService.getofflinePrevBlock().then(result => {
              this.prevShow = result;
            });
        }

      } else if (!online && !this.coreService.initialized) {
        this.navCtrl.setRoot(LoginPage);
      }

    });
  }

  ionViewWillLeave() {
    // enable the root left menu when leaving this page
    this.weeksbinding.unsubscribe();
  }

  /**
   * Visualizza lo stato della settimana
   * @param key indice utente
   */
  checkUserPermission(key: string): boolean {
    if (this.coreService.userKey == key) return true;

    return false;
  }

  /**
   * Funzione autocompletamento
   * @param query stringa ricercata
   * {"autocomplete": ["Marcat Siro"], "managers": {"Marcat Siro": "year/2018/6/siromarcat@gmailcom"}, "places": {}}
   * {"autocomplete": ["Padua", "Padova"], "managers": {}, "places": {"Padua": ["year/2018/6/ggiorgianni@demogoreplyio/1_am"], "Padova": ["year/2018/6/ggiorgianni@demogoreplyio/1_am"]}}
   */
  onChange(query: string) {
    if (query.length > 2) {
      if (!this.network.verifyConnection()) {
        this.showAutocomplete = true;
        this.autocomplete = [];
        this.manager = [];

        for (let user of this.coreService.getUsersList()) {
          if (user.name.toLowerCase().indexOf(query.toLowerCase()) > -1) {
            this.autocomplete.push(user.name);
            this.manager[user.name] = '///' + user.key;
          }
        }

        //console.log(this.autocomplete);

        this.places = [];

      } else {

        this.showAutocomplete = true;
        // console.log(query.length);
        this.coreService.getAutocompleteSearchValues(query).first().subscribe(result => {
          this.autocomplete = result.autocomplete;

          this.manager = result.managers;
          this.places = result.places;
        });

      }
    } else {
      this.showAutocomplete = false;
      this.autocomplete = [];

      this.manager = [];
      this.places = [];
    }
  }

  /**
   * Controlla se la ricerca è attiva
   */
  isQuerying(): boolean {
    if (this.querySearch.length > 0) {
      return true;
    }

    //this.searchedPlace = '';
    return false;
  }

  /**
   * Salva indice autocomplete per ricera
   */
  setSearchQuery(txt: string) {
    //console.log(txt);
    this.querySearch = txt;

    this.showAutocomplete = false;

    this.submitSearch();
    //this.keyboard.close();
  }

  /**
   * Resetta campo ricerca
   */
  resetSearch() {

    this.coreService.setWeeksBinding();

    this.querySearch = '';
    this.autocomplete = [];
    this.manager = [];
    this.places = [];
    this.coreService.setSearchedData(null);

    this.resultsEmpty = false;
    //console.log(this.coreService.getSearchedData());

    this.resetWeekVisible();

  }

  /**
   * Invia la ricera
   */
  submitSearch() {
    if (this.querySearch.length > 2) {
      this.showTravelEvidence = true;
      this.showAutocomplete = false;

      this.coreService.setSearchedData(null);
      this.mantainResearch();

    } else {

      this.showAutocomplete = true;
      this.autocomplete = [];
      this.manager = [];
      this.places = [];
      this.coreService.setSearchedData(null);
      this.resetWeekVisible();
    }
  }

  /**
   * Mantiene la ricera nello spostamento tra settimane
   */
  mantainResearch() {
    let findOnAutocomplete = false;
    this.elementFind = [];

    //console.log(this.coreService.getSearchedData());
    let searchedData = null;
    searchedData = this.coreService.getSearchedData();
    // console.log(this.coreService.getSearchedData());

    if (searchedData) {
      this.moveSearch = this.moveSearch + 1;
      //ricerca settata
      // this.hideWeek();
      // console.log('ricerca providewr');

      let type = searchedData.type;
      this.querySearch = searchedData.query;

      if (type == 0) {
        this.setWeekVisible(searchedData.elements);


      } else if (type == 1) {
        this.coreService.getAutocompleteSearchValues(this.querySearch).first().subscribe(result => {
          this.showTravelEvidence = true;
          this.places = result.places;

          let travelEvidence: any[] = [];
          if (this.places && (this.querySearch in this.places))
            for (let place of this.places[this.querySearch]) {
              // console.log(place); //sollo un manager

              let userkey = place.split('/')[3];
              let index = place.split('/')[4];

              let element_exist = false;
              for (let exist of this.elementFind) {
                if (exist == userkey) {
                  element_exist = true;
                  break;
                }
              }

              if (!element_exist) {
                this.elementFind.push(userkey);
                travelEvidence[userkey] = [index];

              } else {
                travelEvidence[userkey].push(index);
              }

              findOnAutocomplete = true;
            }


          this.elementFind.sort();
          travelEvidence.sort();

          this.setWeekVisible(this.elementFind, this.showTravelEvidence, travelEvidence);

        });
      } else if (type == 2) {
        if (this.network.verifyConnection()) {
          this.coreService.getAutocompleteSearchGeneric(this.querySearch).toPromise().then(results => {
            //console.log(results);
            for (let user of results) {
              let userkey = user.split('/')[3];

              let element_exist = false;
              for (let exist of this.elementFind) {
                if (exist == userkey) {
                  element_exist = true;
                  break;
                }
              }

              if (!element_exist) {
                this.elementFind.push(userkey);
              }
            }

            if (this.elementFind.length == 0) {
              this.setWeekVisible([]);
            } else {
              this.setWeekVisible(this.elementFind);
            }


          }).catch();
        } else {
          //console.log(searchedData.elements);
          this.setWeekVisible(searchedData.elements);
        }

      }

    } else {

      //console.log('save serch submit');
      this.moveSearch = 0;
      //lanciare autocomplete per riottenere lista utenti da visualizzare con lista index per utente array
      if (this.querySearch.length > 0) {
        if (this.manager[this.querySearch]) {

          //console.log(this.manager[this.querySearch]); //solo un manager
          //se manager taglia le prime n lettere
          let userkey = this.manager[this.querySearch].split('/')[3];
          this.elementFind.push(userkey);
          findOnAutocomplete = true;

          this.coreService.setSearchedData({
            type: 0,
            query: this.querySearch,
            elements: this.elementFind
          });

          this.setWeekVisible(this.elementFind);

        } else if (this.places[this.querySearch]) {

          let travelEvidence: any[] = [];
          for (let place of this.places[this.querySearch]) {
            //console.log(place); //sollo un manager

            let userkey = place.split('/')[3];
            let index = place.split('/')[4];

            let element_exist = false;
            for (let exist of this.elementFind) {
              if (exist == userkey) {
                element_exist = true;
                break;
              }
            }

            if (!element_exist) {
              this.elementFind.push(userkey);
              travelEvidence[userkey] = [index];

            } else {
              travelEvidence[userkey].push(index);
            }

            findOnAutocomplete = true;
          }

          this.elementFind.sort();
          travelEvidence.sort();

          this.coreService.setSearchedData({
            type: 1,
            query: this.querySearch
          });

          this.setWeekVisible(this.elementFind, this.showTravelEvidence, travelEvidence);

        } else {

          if (this.network.verifyConnection()) {
            this.coreService.getAutocompleteSearchGeneric(this.querySearch).toPromise().then(results => {

              for (let user of results) {
                let endpoint = user.split('/')[3];
                let userkey = endpoint.split('/')[0];

                let element_exist = false;
                for (let exist of this.elementFind) {
                  if (exist == userkey) {
                    element_exist = true;
                    break;
                  }
                }

                if (!element_exist) {
                  this.elementFind.push(userkey);
                }
              }

              this.coreService.setSearchedData({
                type: 2,
                query: this.querySearch,
                elements: this.elementFind
              });

              if (this.elementFind.length == 0) {
                this.setWeekVisible([]);
              } else {
                this.setWeekVisible(this.elementFind);
              }
            }).catch();
          } else {

            // console.log('mainti off');
            //se manager taglia le prime n lettere
            for (let user of this.coreService.getUsersList()) {
              if (user.name.toLowerCase().indexOf(this.querySearch.toLowerCase()) > -1) {
                this.elementFind.push(user.key);
              }
            }

            findOnAutocomplete = true;

            this.coreService.setSearchedData({
              type: 2,
              query: this.querySearch,
              elements: this.elementFind
            });

            this.setWeekVisible(this.elementFind);
          }
        }
        //se place taglia le prime n lettere e mantiene valore key e mezza giornata se da evidenziare
        //console.log(elementFind);

      } else {

        this.resetWeekVisible();
      }

    }
  }

  /**
   * Filtra la settimana e nasconde gli utenti non desiderati
   */
  setWeekVisible(userList: string[], travelOnly: boolean = false, indexes?: any) {
    //console.log(userList);
    this.hideWeek();
    this.travelSearch = travelOnly;

    if (this.isQuerying()) {
      //console.log(userList);
      if (userList.length == 0)
        this.resultsEmpty = true;
      else
        this.resultsEmpty = false;
    } else {
      this.resultsEmpty = false;
    }

    if (!travelOnly) {
      for (let week of this.week_binding) {
        for (let user of userList) {
          if (user == week.user.key) {
            week.show = true;
            break;
          }
        }
      }
    } else {
      for (let week of this.week_binding) {
        for (let user of userList) {
          if (user == week.user.key) {

            for (let index of this.index_list) {
              if (indexes[user].indexOf(index) > -1) {
                week[index + '_state'] = 'Travel';
              } else {
                delete (week[index + '_state']);
              }
            }

            week.show = true;
            break;
          }
        }
      }
    }

    //console.log(this.week_binding);
    this.show_loading = false;
    //console.log('show week');
    this.keyboard.close();
  }

  /**
   * Configura la settimana per essere visibile
   */
  resetWeekVisible() {
    this.travelSearch = false;
    this.resultsEmpty = false;

    if (this.week_binding.length > 0) {
      for (let week of this.week_binding) {
        week.show = true;
      }
      //  console.log('reset week');      
    }

    this.show_loading = false;
  }

  /**
   * Purge week elimina gli utenti non in leave o travel nella settimana
   */
  purgeWeek() {
    let purgedWeek = [];

    for (let week of this.week_binding) {
      //console.log(week);
      for (let index of this.index_list) {
        if (week[index]) {
          if (legendaStati.indexOf(week[index]) == -1) {
            purgedWeek.push(week);
            break;
          }
        }
      }
    }

    this.week_binding = purgedWeek;
  }

  /**
   * Nasconde la settimana per la ricerca
   */
  hideWeek() {
    for (let week of this.week_binding) {
      week.show = false;
    }
  }

  moveToNextWeek(): void {
    this.onNext = true;
    this.prevShow = true;
    this.checkNextOnce = false;
    this.showTravelEvidence = false;
    this.show_loading = true;
    this.coreService.getNextWeek();
  }

  moveToPreviousWeek(): void {
    this.onPrev = true;
    this.nextShow = true;
    this.checkPrevOnce = false;
    this.showTravelEvidence = false;
    this.show_loading = true;
    this.coreService.getPrevWeek();
  }

  getName(key: string): string {

    for (let i of this.coreService.getListUsers()) {
      if (i.key == key) {
        return i.name;
      }
    }
    return '';

  }

  getDate(date: string): Date {

    let date_new = date.split(' ')[0];
    let date_array = date_new.split('-');

    return new Date(date_array[2] + ' ' + date_array[1] + ' ' + date_array[0]);

  }

  /**
       * Show note se Travel
       * Verifica stato in base al testo
       */
  checkNote(txt: string): boolean {
    let showNote = true;
    for (let i of legendaStati) {
      if (txt == i) {
        showNote = false;
        break;
      }
    }

    for (let i of this.coreService.getLeaveLabel()) {
      if (txt == i) {
        showNote = false;
        break;
      }
    }

    return showNote;
  }

  /**
     * On Press apre la nota della mezza giornata
     */
  openNote(halfday: string, halfday_note: string) {
    let txt = "Place:<br><b>" + halfday + "</b>";

    if (halfday_note)
      txt = txt + '<br><br> Notes:<br> ' + halfday_note;

    if (legendaStati.indexOf(halfday) == -1 && leaveLabel.indexOf(halfday) == -1) {

      let alert = this.alertCtrl.create({
        title: txt,
        buttons: ['CLOSE']
      });
      alert.present();
    }
  }

  defineWeekDays(): Array<string> {

    let firstWeekDay = new Date(this.week_range[0]);
    let baseWeekDay = new Date(this.week_range[0]);

    return [
      new DatePipe("en").transform(new Date(baseWeekDay), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 1), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 2), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 3), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 4), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 5), 'd MMM y'),
      new DatePipe("en").transform(new Date(baseWeekDay).setDate(firstWeekDay.getDate() + 6), 'd MMM y'),
    ];

    ;
  }
}


// WEBPACK FOOTER //
// ./src/pages/ad-view/ad-view.ts